import flow from 'lodash/flow';
import { getUser } from './user';

export const getPublisher = flow(getUser, ({ publisher = {} }) => publisher);
